import { ActiveElement, ArcElement, Chart, ChartEvent, DoughnutController, Legend, Tooltip } from 'chart.js';
import React from 'react';
import { IWithReactRouterProps, withReactRouter } from '../../mixins/router/withReactRouter';
import { Component } from './Component';

Chart.register(DoughnutController);
Chart.register(ArcElement);
Chart.register(Tooltip);
Chart.register(Legend);
// // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Chart.overrides.doughnut.plugins.legend.position = 'bottom';
// // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Chart.overrides.doughnut.plugins.legend.labels.boxWidth = 20;
// // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Chart.overrides.doughnut.plugins.legend.labels.padding = 20;

export type PieChartItem = { id: string; title: string; factor: number; color?: string };

interface IPieChartOwnProps {
    data: PieChartItem[];
    onClick: (item: PieChartItem) => void;
}

interface IPieChartProps extends IWithReactRouterProps, IPieChartOwnProps {}

class PieChartComponent extends Component<IPieChartProps> {
    private canvasRef: any;
    private myChart: any;

    constructor(props: IPieChartProps) {
        super(props);
        this.canvasRef = React.createRef();
    }

    public override componentDidUpdate() {
        const formattedData = this.getFormattedData();
        this.myChart.data.labels = formattedData.labels;
        this.myChart.data.datasets[0] = formattedData.datasets[0];
        this.myChart.update();
    }

    public override componentDidMount() {
        // https://stackoverflow.com/questions/59719102/how-to-make-onclick-events-for-points-in-a-react-chart-js
        const onClick = (_event: ChartEvent, elements: ActiveElement[]) => {
            if (elements[0]) {
                const activeElement = elements[0];
                const { index } = activeElement;
                this.props.onClick(this.props.data[index]!);
            }
        };

        const formattedData = this.getFormattedData();
        this.myChart = new Chart(this.canvasRef.current, {
            type: 'doughnut',
            options: {
                events: ['click', 'mousemove'],
                onClick,
                responsive: true,
            },
            data: formattedData,
        });
    }

    public override render() {
        return <canvas ref={this.canvasRef} height={400} />;
    }

    private getFormattedData() {
        const defaultColor = 'rgba(44, 44, 44, 0.7)';

        return {
            labels: this.props.data.map((i) => i.title),
            datasets: [
                {
                    backgroundColor: this.props.data.map((i) => i.color ?? defaultColor),
                    data: this.props.data.map((i) => i.factor),
                },
            ],
        };
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PieChart = withReactRouter(PieChartComponent) as React.ComponentType<IPieChartOwnProps>;
